/* eslint-disable import/order */
import { MenuIdStatusPageManage } from '@jira/navigation-apps__constants/src/MenuIdStatusPageManage.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { communicationsStatusPagePreviewRoute } from '@jira/router-routes__communications-routes/src/communicationsStatusPagePreviewRoute.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { StatusPagePreviewPageEntryPoint } from './ui/status-page-preview/StatusPagePreviewPageEntryPoint.tsx';

export const communicationsStatusPagePreviewRouteEntry: Route = createEntry(
	communicationsStatusPagePreviewRoute,
	() => ({
		group: 'communications',

		navigation: {
			menuId: MenuIdStatusPageManage,
		},
		// @ts-expect-error - Layout supports isChromeless but type does not
		layout: {
			isChromeless: true,
		},

		entryPoint: () => {
			return StatusPagePreviewPageEntryPoint;
		},

		resources: [...getNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
